(function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { 
    threshold: 0,     // déclenche dès le premier pixel visible
    rootMargin: '0px 0px 50px 0px'
  });

  function initAnimations() {
    document.querySelectorAll('[data-animate]').forEach(el => {
      // Force le re-observe même si déjà visible
      observer.unobserve(el);
      observer.observe(el);
    });
  }

  // Attendre que tout soit chargé
  window.addEventListener('load', initAnimations);
  document.addEventListener('shopify:section:load', initAnimations);
  document.addEventListener('shopify:block:select', initAnimations);
})();
